import { Cadastro } from './../../../../../shared/interfaces/cadastro';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { BehaviorSubject } from 'rxjs';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { PageResult } from 'app/shared/interfaces/page-result';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CadastroOcorrencia } from 'app/shared/interfaces/cadastro-ocorrencia';
import { OcorrenciaPopupComponent } from '../ocorrencia-popup/ocorrencia-popup.component';

@Component({
  selector: 'app-cadastro-ocorrencia-popup',
  templateUrl: './cadastro-ocorrencia-popup.component.html',
  styleUrls: ['./cadastro-ocorrencia-popup.component.scss']
})
export class CadastroOcorrenciaPopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginatorOcorrencia: MatPaginator;

  layoutConf: any;
  pageObjectOcorrencia$: BehaviorSubject<PageResult<CadastroOcorrencia>> = new BehaviorSubject<PageResult<CadastroOcorrencia>>(null);
  ocorrencias: CadastroOcorrencia[];
  pageOcorrencia = 1;
  lengthOcorrencia = 0;
  pageSizeOcorrencia = 5;
  pageEventOcorrencia = null;
  pageSizeOptionsOcorrencia: number[] = [5, 10, 25];
  cadastro: Cadastro;
  selectedOrdem = 'NENHUM';
  selectedDirect = 'DESC';
  dialogRefOcorrencia: MatDialogRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroOcorrenciaPopupComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private cdr: ChangeDetectorRef,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;

    this.pageObjectOcorrencia$.subscribe(
      page => {
        if (page != null) {
          this.ocorrencias = page.content;
          this.lengthOcorrencia = page.totalElements;
          this.pageSizeOcorrencia = page.size;
          this.pageOcorrencia = page.number;
          if (this.pageOcorrencia === 1 && this.paginatorOcorrencia) {
            this.paginatorOcorrencia.firstPage();
          }
        } else {
          this.ocorrencias = [];
        }
        this.cdr.markForCheck();
      });

    this.getPageOcorrencia(this.pageOcorrencia, this.pageSizeOcorrencia, this.cadastro.id);
  }

  getPageOcorrencia(page: number, pageSize: number, id: number) {
    if (id !== undefined) {
      this.cadastroService.getPageOcorrencia(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString()).subscribe(val => { this.pageObjectOcorrencia$.next(val) })
    }
  }

  reloadPageOcorrencia() {
    this.pageOcorrencia = 1;
    this.getPageOcorrencia(this.pageOcorrencia, this.pageSizeOcorrencia, this.cadastro.id);
  }

  deleteOcorrencia(data: CadastroOcorrencia = {}) {
    this.confirmService.confirm({ message: `Deletar ocorrência "${data?.ocorrencia ?? ''}"?` })
      .subscribe(res => {
        if (res) {
          this.loader.open();
          this.cadastroService.deleteCadastroOcorrencia(data.id)
            .subscribe({
              next: data2 => {
                this.loader.close();
                this.confirmService.confirm({
                  title: data2.status ? 'Sucesso' : 'Erro', message: data2.status
                    ? `Ocorrência deletada!`
                    : `Erro ao deletar ocorrência (há dependências).`, error: false
                });
                if (data2.status) {
                  this.getPageOcorrencia(1, this.pageSizeOcorrencia, this.cadastro.id);
                }
              },
              error: (error: HttpErrorResponse) => {
                this.loader.close();
                const message = error?.status === 404
                  ? `Ocorrência não encontrada para exclusão.`
                  : `Erro ao deletar ocorrência.`;
                this.confirmService.confirm({ title: 'Erro', message, error: true });
              }
            })
        }
      })
  }

  popUpOcorrencia(data: CadastroOcorrencia = {}, isNew?: boolean) {
    const title = isNew ? 'Nova Ocorrência' : 'Alterar Ocorrência';
    this.dialogRefOcorrencia = this.dialog.open(OcorrenciaPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '70%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title, payload: data, cadastroId: this.cadastro.id, isNew: !!isNew }
    })

    this.dialogRefOcorrencia.afterClosed().subscribe(res => {
      if (res) {
        this.reloadPageOcorrencia();
      }
    });
  }

  setPageSizeOptionsOcorrencia(event: PageEvent) {
    this.pageSizeOcorrencia = event.pageSize;
    this.getPageOcorrencia(event.pageIndex + 1, event.pageSize, this.cadastro.id);
  }

  close() {
    this.dialogRef.close();
  }

}
